const fontSizeContainerCls = "_n29fjylem1";
const scaleContainerCls = "_n29s1hpk9g7";
const containerCls = "_n29c14aplm0";

export { containerCls, fontSizeContainerCls, scaleContainerCls };
import "./Text.style.linaria.module.css";
//# sourceMappingURL=Text.style.js.map
